import React from "react";

const ostContext = React.createContext();

export default ostContext;